import React, { useState } from 'react';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaLinkedinIn,
  FaYelp,
  FaPhone,
  FaEnvelope,
  FaClock
} from 'react-icons/fa';

const TopBar = () => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const socialLinks = [
    {
      icon: <FaFacebookF size={14} />,
      url: 'https://www.facebook.com/profile.php?id=100065186183088&mibextid=ZbWKwL',
      name: 'Facebook',
      color: '#1877F2'
    },
    {
      icon: <FaInstagram size={14} />,
      url: 'https://www.instagram.com/greenmelbournecarpetcleaning/',
      name: 'Instagram',
      color: '#E4405F'
    },
    {
      icon: <FaLinkedinIn size={14} />,
      url: 'https://linkedin.com',
      name: 'LinkedIn',
      color: '#0A66C2'
    },
    {
      icon: <FaYelp size={14} />,
      url: 'https://yelp.com',
      name: 'Yelp',
      color: '#D32323'
    }
  ];

  return (
    <div className="top-bar">
      <div className="container">
        <div className="top-bar-content">
          {/* Contact Information */}
          <div className="top-contact-info">
            <div className="top-contact-item">
              <FaPhone className="top-contact-icon" />
              <span>+61 1300 989 330</span>
            </div>
            <div className="top-contact-item">
              <FaEnvelope className="top-contact-icon" />
              <span>greenrockycarpet@gmail.com</span>
            </div>
            <div className="top-contact-item">
              <FaClock className="top-contact-icon" />
              <span>Sat-Fri: 24 Hours</span>
            </div>
          </div>

          {/* Social Links & Additional Info */}
          <div className="top-bar-right">
            <div className="social-links">
              <span className="social-label">Follow Us:</span>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <div key={index} className="social-link-wrapper">
                    <a
                      href={social.url}
                      className="social-link"
                      aria-label={social.name}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ '--social-color': social.color }}

                    >
                      {social.icon}
                    </a>
                    {activeTooltip === index && (
                      <div className="social-tooltip">
                        {social.name}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            
            <div className="top-bar-badge">
              <span className="badge-text">
                <a href="#" target='_blank'>Login</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;